<template>
    <div>
      <div style="text-align: center">
        <h3>Tambah Device</h3>
      </div>
      <br />
      <form v-on:submit.prevent="addDevice">
        <label>Nama Device</label>
        <input type="text" class="form-control" v-model="form.name" autofocus required />
        <br />
        <label>Tipe Whatsapp</label>
        <select v-model="form.multidevice" class="form-control">
            <option value="1">Multidevice</option>
        </select>
        <br />
        <div v-if="form.multidevice == '1'">
            Catatan Untuk Multidevice
            <br>
            <b> 1. Multidevice whatsapp masih berstatus beta, mungkin berberapa fitur masih kurang stabil </b>
            <br>
            <b> 2. Resiko banned saat kirim pesan blast terutama untuk nomor yang belum dikenal lebih tinggi </b>
            <br>
        </div>
        <label>Tipe Server</label>
        <select v-model="form.type" class="form-control">
            <option value="unofficial" selected>Unofficial API</option>
          <!--  <option value="official" disabled>Official API (Akan Datang)</option>-->
        </select>
        <br />
        <div class="alert alert-light" style="border:1px solid #e2e8f0;padding:10px 12px;border-radius:8px">
          <label class="d-flex align-items-center mb-0" style="cursor:pointer">
            <input type="checkbox" v-model="form.passkey" style="margin-right:8px;width:16px;height:16px" />
            <span><b>Tautkan dengan Passkey</b><br><small class="text-muted">Pilih ini jika WhatsApp Anda meminta passkey saat menautkan device. Perlu extension StarSender Passkey Helper.</small></span>
          </label>
          <a href="/passkey/panduan.html" target="_blank" style="display:inline-block;margin-top:8px;font-weight:700;color:#4f46e5;text-decoration:none;font-size:13px">&#128229; Download extension &amp; panduan lengkap &rarr;</a>
        </div>
        <div class="button-group d-flex pt-25">
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block" :disabled="isSubmitting">
              <span v-if="isSubmitting">Menyimpan...</span>
              <span v-else>Tambah</span>
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isSubmitting: false, // fix-double-submit-545
        form: {
          name: "",
          multidevice: "1",
          type: "unofficial",
          passkey: false
        },
      };
    },
    mounted() {
  
    },
    methods: {
      async addDevice(){
        if (this.isSubmitting) return
        this.isSubmitting = true
        try{
          let request = { ...this.form }
          request.multidevice = parseInt(request.multidevice)
          let response = await this.$store.dispatch('device_create', request)
          
          this.$toast.success(response.data.message);
          this.form.name = ""
          this.$root.$emit("toggle_modal", "new_device")
          this.$root.$emit("refresh_table", true)
        }catch(err){
          this.$toast.error(err.response?.data?.message || "Gagal menambah device");
        } finally {
          this.isSubmitting = false
        }
      },
    },
  };
  </script>
  
